var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showBannerAdvertising)?_c('div',{staticClass:"advertising"},[(_vm.$tenant.advertising.type == 'default' && _vm.isAllowed('default'))?_c('banner-advertising-slide-content'):_vm._e(),(_vm.$tenant.advertising.type == 'adspirit' && _vm.isAllowed('adspirit') && _vm.consentGiven('AdSpirit'))?_c('ad-spirit-advertising'):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }